import React from 'react';
export function CierreSection() {
  return <section className="py-10 px-5 text-center bg-[#fff3e0]" data-id="element-46">
      <div className="max-w-md mx-auto" data-id="element-47">
        <p className="text-[1.2rem] font-semibold text-gray-900 leading-relaxed mb-4" data-id="element-48">
          Los primeros años no vuelven...
          <br data-id="element-49" />
          Pero lo que hagas hoy vivirá en su mente para siempre.
        </p>
        <p className="text-base text-gray-800 leading-relaxed mb-6" data-id="element-50">
          👶 Tú puedes ser su primer gran maestro(a).
          <br data-id="element-51" />Y este momento… es el mejor comienzo.
        </p>
        <button className="w-full text-white font-bold text-base py-4 px-5 rounded-xl text-center" style={{
        backgroundColor: '#f50057',
        boxShadow: '0 4px 18px rgba(245, 0, 87, 0.4)'
      }} onClick={() => {
        const section = document.getElementById('oferta-especial');
        if (section) {
          section.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }} data-id="element-52">
          💛 QUIERO AYUDAR A MI BEBÉ DESDE HOY
        </button>
      </div>
    </section>;
}